<template>
  <b-form-group :state="nameState">
    <label class="form__label input-label">Name</label>
    <b-form-input
      v-model.trim="$v.name.$model"
      placeholder="Enter your name"
      autocomplete="off"
      :state="nameState"
      class="sing-up-input"
    />
    <template #invalid-feedback>
      <div v-if="!$v.name.required || !$v.name.minLength || !$v.name.maxLength || !$v.name.atLeastOneLetter || !$v.name.userNameAllowedCharacters" v-html="VALIDATION_MESSAGES.universalNameValidation"></div>
      <div v-else v-for="(error, index) in serverErrors" :key="index">
        {{ error }}
      </div>
    </template>

    <!-- <template #invalid-feedback>
      <div v-if="!$v.name.required">{{ VALIDATION_MESSAGES.common.required }}</div>
      <div v-else-if="!$v.name.minLength">{{ VALIDATION_MESSAGES.common.minLength($v.name.$params.minLength.min) }}</div>
      <div v-else-if="!$v.name.maxLength">{{ VALIDATION_MESSAGES.common.maxLength($v.name.$params.maxLength.max) }}</div>
      <div v-else-if="!$v.name.atLeastOneLetter">{{ VALIDATION_MESSAGES.common.atLeastOneLetter }}</div>
      <div v-else-if="!$v.name.userNameAllowedCharacters" v-html="VALIDATION_MESSAGES.userName.allowedCharactersHTML"></div>
      <div v-else v-for="(error, index) in serverErrors" :key="index">
        {{ error }}
      </div>
    </template> -->
  </b-form-group>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import { atLeastOneUnicodeLetter, userNameAllowedCharacters, noSpacesAtEdges } from '@utils/validators'

export default {
  name: 'UserNameField',
  mixins: [validationMixin],
  props: {
    initial_name: {
      type: String,
      default: ''
    },
    serverErrors: [Array, null],
    hideValidationErrors: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    this.name = this.initial_name
  },
  data () {
    return {
      name: ''
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(70),
      atLeastOneLetter: atLeastOneUnicodeLetter,
      userNameAllowedCharacters,
      noSpacesAtEdges
    }
  },
  computed: {
    nameState () {
      if (this.hideValidationErrors) {
        return null
      }

      return this.serverErrors || this.$v.name.$invalid ? false : null
    }
  }
}
</script>
